import { Handle, Position } from "@xyflow/react";
import { useCanvasEditability } from "../../lib/canvas-editability";
import { CONNECTION_POINTS, type ConnectionPoint } from "../../lib/canvas-connections";
import type { BoardNodeData } from "../../types/board";

const positions: Record<ConnectionPoint, Position> = {
  top: Position.Top, right: Position.Right, bottom: Position.Bottom, left: Position.Left,
};
export function BoardNodeHandles({ type, isConnectable }: { type: BoardNodeData["type"]; isConnectable: boolean }) {
  const { canEditDocument } = useCanvasEditability();
  return CONNECTION_POINTS[type].map(point => <Handle key={point} id={point} type="source" position={positions[point]}
    isConnectable={canEditDocument && isConnectable} className="board-connection-point"
    aria-label={`${point} connection point`} />);
}
